module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_4_5.ee5b297c.png";